import { Component, Pipe, PipeTransform, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServicesProceduresPageStore } from './services-procedures-page.store';
import { activeColumn, longTextField } from '../../../../shared/components/kit/table/table.fields';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { fb, routeParams, router } from '../../../../shared/shared.global-service';
import { ActivatedRoute } from '@angular/router';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import {
    ServiceMedicalProcedureObject,
} from '@libs/types/src/services/object-type/service/service-medical-procedure.object';
import { contentGlobalSuccess } from '../../../content.error';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionButtonsComponent } from '../../../../../components/kit/action-buttons/action-buttons.component';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TagComponent } from '../../../../../components/kit/tag/tag.component';
import {
    SearchMedicalProcedureComponent,
} from '../../../components/common/search-medical-procedure/search-medical-procedure.component';
import { GreenOrRedDotComponent } from '../../../../../components/kit/green-or-red-dot/green-or-red-dot.component';
import {
    transformSingleServiceProcedure, TransformSingleServiceProcedurePipe,
} from '../../../../shared/components/kit/performed-procedures/performed-procedures.pipes';
import { TableColumnType } from '../../../../shared/components/kit/table/table.types';

@Pipe({
    name: 'transformServiceProceduresData',
})

export class TransformServiceProceduresDataPipe implements PipeTransform {
    public transform(items: any[]): any {
        return (items || []).map((item) => ({
            applications: item.applications || 1,
            medicalProcedure: {
                code: item.customCode || item.procedure?.customCode || item.code || item.medicalProcedure?.code || '',
                description: item.customName || item.procedure?.description || item.description || item.medicalProcedure?.description || '',
                color: item.color || item.procedure?.color || item.medicalProcedure?.procedure?.color,
            },
        }));
    }
}

@Component({
    selector: 'app-services-procedures-page',
    templateUrl: 'services-procedures-page.component.html',
    styleUrls: ['services-procedures-page.component.scss'],
    providers: [ServicesProceduresPageStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        ActionButtonsComponent,
        CardTableComponent,
        PrimeTemplate,
        TagComponent,
        SearchMedicalProcedureComponent,
        GreenOrRedDotComponent,
        TransformSingleServiceProcedurePipe,
    ],
})
export class ServicesProceduresPageComponent extends SubscriptionComponent {
    protected readonly store = inject(ServicesProceduresPageStore);
    private readonly route = inject(ActivatedRoute);
    private readonly confirm = inject(ConfirmBuilder);


    @ViewChild('procedureGrid') procedureGrid!: TableComponent;

    protected form = fb.group({
        procedures: fb.control<string[]>([]),
        expertiseCodes: fb.control<string[]>([]),
    });

    protected visible = false;

    protected columns = [
        activeColumn,
        {
            name: 'codes',
            type: TableColumnType.PerformedProcedures,
            dataKey: null,
            data: (item: ServiceMedicalProcedureObject) => [transformSingleServiceProcedure(item)],
            filterable: {
                hideOperators: true,
            },
            sortable: true,
        },
        longTextField('name'),
        { name: 'rule' },
    ];

    protected async goToDetail(item: ServiceMedicalProcedureObject): Promise<void> {
        await router.navigate([item.id], { relativeTo: this.route });
    }

    protected async createProcedure(): Promise<void> {
        if (!this.form.value.procedures?.length) return;

        await this.store.api.createServiceMedicalProcedure({
            serviceId: Number(routeParams.serviceId()),
            codes: this.form.value.procedures.filter(p => !!p),
        });
        this.show(false);
        this.form.reset();
        contentGlobalSuccess.next('common.created');
        this.procedureGrid?.reload();
    }

    protected show(visible: boolean = true): void {
        this.visible = visible;
    }

    protected setActive(item: ServiceMedicalProcedureObject) {
        this.store.api.updateServiceMedicalProcedure({
            id: item.id,
            active: !item.active,
        }).then(() => {
            contentGlobalSuccess.next('common.updated');
            this.procedureGrid?.reload();
        });
    }

    protected deleteProcedure(item: any): void {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteServiceMedicalProcedure({ id: item.item.id });
                contentGlobalSuccess.next('common.deleted');
                this.procedureGrid?.reload();
            },
            item,
        );
    }

    protected readonly routeParams = routeParams;
}
